export default __webpack_public_path__ + "static/5-switch-184bf254369c978b24ac6b149aef7e50.jpg";